import type { ThirdPartyResponseByIdResponseRow } from '@risksmart-app/drizzle/src/types';
import type { GetThirdPartyResponseByIdQuery } from '@risksmart-app/web-graphql-client/generated/graphql';
import { GetThirdPartyResponseByIdDocument } from '@risksmart-app/web-graphql-client/generated/graphql';
import { createQueryHook } from 'src/utils';

type UseGetThirdPartyResponseByIdArgs = { id: string };

export const useGetThirdPartyResponseById = createQueryHook<
  UseGetThirdPartyResponseByIdArgs,
  ThirdPartyResponseByIdResponseRow | null,
  GetThirdPartyResponseByIdQuery
>({
  trpcQueryOptions: (trpc, { id }) =>
    trpc.frontend.thirdPartyResponse.getById.queryOptions({ id }),
  mapTrpcDataToGraphQL: (data) => ({
    third_party_response_by_pk: data ?? null,
  }),
  graphqlDocument: GetThirdPartyResponseByIdDocument,
  graphqlVariables: ({ id }) => ({ Id: id }),
});
